<div class="kt-portlet">
    <div class="kt-portlet__head kt-portlet__head__custom">
        <div class="kt-portlet__head-progress">
            <!-- Progress bar placeholder -->
        </div>
        <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon kt-hide">
                <i class="la la-gear"></i>
            </span>
        </div>
    </div>
    <div class="kt-form">
        <div class="kt-portlet__body">
            <div class="form-group kt-form__group row">
                <div class="col-lg-12">
                    Delete {{ data.type === 'service' ? 'Service' : (data.type === 'group' ? 'Service Group' :
                    'Escalation Policy') }}?
                </div>
            </div>
        </div>
        <div class="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit text-end">
            <div class="kt-form__actions kt-form__actions--sm">
                <button type="button" mat-button class="delete_cancel_btn" (click)="onCancel()">Cancel</button>&nbsp;
                <button type="button" mat-button class="btn-add" (click)="onConfirm()" cdkFocusInitial>Delete</button>
            </div>
        </div>
    </div>
</div>
